module.exports = __webpack_public_path__ + "img/hero.1ee1fd47.jpg";